export const giftWrappingIDs = [
  '8693',
  '12932',
  '12933',
  '12935',
  '12940',
  '12945',
  '15128',
  '18781',
  '18782',
  '18783',
  '18784',
  '18785',
  '18786',
  '18787',
  '18788',
  '18789',
  '18790',
  '18791',
  '18794',
  '18795',
  '18796',
  '18797',
  '18798',
  '18799',
  '18800',
  '18801',
  '18802',
  '19087',
  '19527',
  '19671',
  '19690',
  '19691',
  '19692',
  '19693',
  '19694',
  '19695',
  '19696',
  '19697',
  '19698',
  '19700',
  '19701',
  '19702',
  '19705',
  '19706',
  '19707',
  '19708',
  '19709',
  '19710',
  '19711',
  '19712',
  '19713',
  '19714',
  '19715',
  '19716',
  '19717',
  '19718',
  '19719',
  '19720',
  '19721',
  '19722',
  '19723',
  '20360',
  '20638',
  '20639',
  '23761',
  '23793',
  '23794',
  '33155',
  '33156',
  '33335',
  '33352',
  '33356',
  '33357',
  '33476',
  '33477',
  '33478',
  '33479',
  '33480',
  '33481',
  '33482',
  '33483',
  '33484',
  '33485',
  '33486',
  '33487',
  '33529',
  '34246',
  '34247',
  '34248',
  '34249',
  '34250',
  '34251',
  '34252',
  '34253',
  '34254',
  '34255',
  '34369',
]
